var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17 28.133c1.68-.373 2.256-1.4 2.333-1.866v-21c-.7-2.1-3.266-2.1-3.733-2.334-.373-.186-.155-.7 0-.933h12.367l.233.233c-.078.39-.607 1.167-2.1 1.167-1.493 0-2.8 1.244-3.267 1.867-.077 6.455-.186 19.693 0 21 .187 1.306 1.634 1.789 2.334 1.866 2.489 0 7.746-.14 8.866-.7 1.4-.7 2.567-3.966 3.034-4.666.466-.7 1.4 0 1.4.7 0 .56-1.245 4.589-1.867 6.533-6.922-.078-20.907-.28-21.467-.467-.7-.233-.233-.933 1.867-1.4z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgld);
export default __webpack_public_path__ + "static/media/AGLD.c36cf5878c52528fd57c879253b82da6.svg";
export { ForwardRef as ReactComponent };